import { Box, ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { FilterRowProps } from "web_myplann/NotificationCenter/Types/FilterRowProps";

const RADIO_SIZE = 20;
const RADIO_DOT_SIZE = 8;

export const FilterRowV2: FC<FilterRowProps> = ({
	label,
	selected,
	onClick,
	isLast,
	testId,
}) => {
	const { palette, radii, spacingTokens } = useTheme();

	return (
		<ButtonBase
			onClick={onClick}
			data-testid={testId}
			role="radio"
			aria-checked={selected}
			sx={{
				width: "100%",
				justifyContent: "space-between",
				px: spacingTokens.lg,
				py: 1.4,
				borderBottom: isLast ? "none" : `1px solid ${palette.surface.border}`,
				"&:active": { backgroundColor: palette.grey[50] },
			}}
		>
			<Typography variant="body2" color={palette.grey[900]}>
				{label}
			</Typography>
			{selected && (
				<Stack
					alignItems="center"
					justifyContent="center"
					flexShrink={0}
					width={RADIO_SIZE}
					height={RADIO_SIZE}
					borderRadius={radii.full}
					bgcolor={palette.blue[600]}
				>
					<Box
						width={RADIO_DOT_SIZE}
						height={RADIO_DOT_SIZE}
						borderRadius={radii.full}
						bgcolor={palette.darkmodeText.white}
					/>
				</Stack>
			)}
		</ButtonBase>
	);
};
